(() => {
  const root = document.getElementById('KlaimScratchcardPopup');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const config = {
    companyId: root.dataset.companyId,
    listId: root.dataset.listId,
    formName: root.dataset.formName,
    discountEndpoint: root.dataset.discountEndpoint,
    previewParam: root.dataset.previewParam || 'klaim_scratch_preview',
    previewResetParam: root.dataset.previewResetParam || 'klaim_scratch_reset'
  };

  const rewards = [
    { weight: 20, title: '5% off', rule: 'On your next order', code: 'SCRATCH5', note: 'One use per customer. Applies at checkout.', redirect: '/' },
    { weight: 55, title: '10% off', rule: 'On your next order', code: 'SCRATCH10', note: 'One use per customer. Applies at checkout.', redirect: '/' },
    { weight: 20, title: 'Free shipping', rule: 'On your next order', code: 'SCRATCHSHIP', note: 'One use per customer. Covers shipping up to \u20ac15.', redirect: '/' },
    { weight: 5, title: 'Free Yeezy Slide', rule: 'One Slide on qualifying orders from \u20ac175', code: 'YEEZY175', note: 'Choose one available Black, Cream or Fudge Slide. Minimum \u20ac175 qualifying spend.', redirect: '/search?q=yeezy+slide&type=product' }
  ];

  const keys = {
    reward: 'klaim-scratchcard-reward-v2',
    claimed: 'klaim-scratchcard-claimed-v2',
    scratched: 'klaim-scratchcard-scratched-v1',
    nextEligibleAt: 'klaim-scratchcard-next-eligible-at-v1',
    dismissedUntil: 'klaim-scratchcard-dismissed-until-v2',
    teaserDismissedUntil: 'klaim-scratchcard-teaser-dismissed-until-v2',
    legacyTeaserDismissedUntil: 'klaim-scratchcard-teaser-dismissed-until-v1',
    teaserDismissedForSession: 'klaim-scratchcard-teaser-dismissed-session-v1',
    autoOpenedForSession: 'klaim-scratchcard-auto-opened-session-v1'
  };

  const DAY_MS = 24 * 60 * 60 * 1000;
  const VISITOR_COOLDOWN_MS = 5 * DAY_MS;
  const SUBSCRIBER_COOLDOWN_MS = 45 * DAY_MS;

  const dialog = root.querySelector('[data-scratch-dialog]');
  const surface = root.querySelector('[data-scratch-surface]');
  const canvas = root.querySelector('[data-scratch-canvas]');
  const dust = root.querySelector('[data-scratch-dust]');
  const progress = root.querySelector('[data-scratch-progress]');
  const status = root.querySelector('[data-scratch-status]');
  const revealButton = root.querySelector('[data-scratch-reveal]');
  const form = root.querySelector('[data-scratch-form]');
  const emailInput = root.querySelector('[data-scratch-email]');
  const websiteInput = root.querySelector('[data-scratch-website]');
  const submitButton = root.querySelector('[data-scratch-submit]');
  const error = root.querySelector('[data-scratch-error]');
  const intro = root.querySelector('[data-scratch-intro]');
  const main = root.querySelector('[data-scratch-main]');
  const success = root.querySelector('[data-scratch-success]');
  const successTitle = root.querySelector('[data-success-title]');
  const rewardTitle = root.querySelector('[data-reward-title]');
  const rewardRule = root.querySelector('[data-reward-rule]');
  const rewardCode = root.querySelector('[data-code-value]');
  const copyButton = root.querySelector('[data-copy-code]');
  const shopButton = root.querySelector('[data-scratch-shop]');
  const closeButtons = [...root.querySelectorAll('[data-scratch-close]')];
  const closeButton = closeButtons.find((button) => button.tagName === 'BUTTON');
  const teaser = document.getElementById('KlaimScratchcardTeaser');
  const teaserOpen = teaser?.querySelector('[data-scratch-teaser-open]');
  const teaserClose = teaser?.querySelector('[data-scratch-teaser-close]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(pointer: fine)');
  const query = new URLSearchParams(window.location.search);
  const previewRequested = query.get(config.previewParam) === '1';
  const previewResetRequested = query.get(config.previewResetParam) === '1';
  const trustedPreviewContext = query.has('preview_theme_id') || Boolean(window.Shopify?.designMode);
  const preview = previewRequested && (trustedPreviewContext || previewResetRequested);
  const previewReset = preview && previewResetRequested;

  let reward = getReward();
  let issuedCode = '';
  let context;
  let dpr = 1;
  let drawing = false;
  let revealed = false;
  let lastPoint = null;
  let moveCount = 0;
  let progressFrame = null;
  let brushDiameter = 52;
  let previousFocus = null;
  let closeTimer = null;
  let mainHideTimer = null;
  let revealHoldTimer = null;
  let openTimer = null;

  function safeGet(storage, key) {
    try { return storage.getItem(key); } catch (_) { return null; }
  }

  function safeSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (_) { /* Storage may be blocked. */ }
  }

  function safeRemove(storage, key) {
    try { storage.removeItem(key); } catch (_) { /* Storage may be blocked. */ }
  }

  function resetPreviewState() {
    if (!previewReset) return;
    [
      keys.claimed,
      keys.scratched,
      keys.nextEligibleAt,
      keys.dismissedUntil,
      keys.teaserDismissedUntil,
      keys.legacyTeaserDismissedUntil
    ].forEach((key) => {
      safeRemove(window.localStorage, key);
    });
    safeRemove(window.sessionStorage, keys.reward);
    safeRemove(window.sessionStorage, keys.teaserDismissedForSession);
    safeRemove(window.sessionStorage, keys.autoOpenedForSession);
  }

  resetPreviewState();

  function pickReward() {
    const random = new Uint32Array(1);
    window.crypto.getRandomValues(random);
    let roll = (random[0] / 4294967296) * 100;
    return rewards.find((candidate) => ((roll -= candidate.weight) < 0)) || rewards[0];
  }

  function getReward() {
    const storedCode = safeGet(window.sessionStorage, keys.reward);
    const storedReward = rewards.find((candidate) => candidate.code === storedCode);
    if (storedReward) return storedReward;
    const selected = pickReward();
    safeSet(window.sessionStorage, keys.reward, selected.code);
    return selected;
  }

  function setReward() {
    root.dataset.rewardCode = reward.code;
    rewardTitle.textContent = reward.title;
    rewardRule.textContent = reward.rule;
    rewardCode.textContent = issuedCode;
    shopButton.href = issuedCode
      ? `/discount/${encodeURIComponent(issuedCode)}?redirect=${encodeURIComponent(reward.redirect)}`
      : reward.redirect;
    shopButton.setAttribute('aria-label', issuedCode
      ? `Apply ${reward.title} and shop`
      : `Shop ${reward.title}`);
  }

  function nextEligibleAt() {
    const stored = Number(safeGet(window.localStorage, keys.nextEligibleAt) || 0);
    if (stored > 0) {
      if (!safeGet(window.localStorage, keys.claimed) && stored > Date.now() + VISITOR_COOLDOWN_MS) {
        const migratedVisitorCooldown = Date.now() + VISITOR_COOLDOWN_MS;
        safeSet(window.localStorage, keys.nextEligibleAt, String(migratedVisitorCooldown));
        safeSet(window.localStorage, keys.dismissedUntil, String(migratedVisitorCooldown));
        return migratedVisitorCooldown;
      }
      return stored;
    }

    const legacyDismissal = Math.max(
      Number(safeGet(window.localStorage, keys.dismissedUntil) || 0),
      Number(safeGet(window.localStorage, keys.legacyTeaserDismissedUntil) || 0)
    );
    if (legacyDismissal > 0) {
      const migratedDismissal = safeGet(window.localStorage, keys.claimed)
        ? legacyDismissal
        : Math.min(legacyDismissal, Date.now() + VISITOR_COOLDOWN_MS);
      safeSet(window.localStorage, keys.nextEligibleAt, String(migratedDismissal));
      return migratedDismissal;
    }

    if (safeGet(window.localStorage, keys.claimed)) {
      const migratedClaimCooldown = Date.now() + SUBSCRIBER_COOLDOWN_MS;
      safeSet(window.localStorage, keys.nextEligibleAt, String(migratedClaimCooldown));
      return migratedClaimCooldown;
    }

    return 0;
  }

  function setPopupCooldown(duration) {
    const until = Date.now() + duration;
    const value = String(until);
    safeSet(window.localStorage, keys.nextEligibleAt, value);
    safeSet(window.localStorage, keys.dismissedUntil, value);
  }

  function setFullCooldown(duration) {
    setPopupCooldown(duration);
  }

  function clearPendingOffer() {
    safeRemove(window.localStorage, keys.scratched);
    safeRemove(window.sessionStorage, keys.reward);
  }

  function drawCover() {
    if (revealed || root.hidden) return;
    const rect = surface.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
    canvas.width = Math.round(rect.width * dpr);
    canvas.height = Math.round(rect.height * dpr);
    context = canvas.getContext('2d', { willReadFrequently: true });

    const gradient = context.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop(0, '#642907');
    gradient.addColorStop(.42, '#070809');
    gradient.addColorStop(1, '#222b33');
    context.fillStyle = gradient;
    context.fillRect(0, 0, canvas.width, canvas.height);

    const grainCount = Math.min(3200, Math.round((canvas.width * canvas.height) / 650));
    for (let index = 0; index < grainCount; index += 1) {
      const alpha = .025 + (Math.random() * .075);
      context.fillStyle = Math.random() > .5
        ? `rgba(255, 255, 255, ${alpha})`
        : `rgba(0, 0, 0, ${alpha})`;
      const size = Math.max(1, Math.random() * 1.6 * dpr);
      context.fillRect(Math.random() * canvas.width, Math.random() * canvas.height, size, size);
    }

    const titleSize = Math.max(19, Math.min(32, rect.width * .065)) * dpr;
    context.fillStyle = '#ffffff';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.font = `700 ${titleSize}px Helvetica, Arial, sans-serif`;
    context.fillText('SCRATCH HERE', canvas.width / 2, canvas.height / 2);
  }

  function pointFromEvent(event) {
    const rect = canvas.getBoundingClientRect();
    return { x: (event.clientX - rect.left) * dpr, y: (event.clientY - rect.top) * dpr };
  }

  function brushDiameterFromEvent(event) {
    if (event.pointerType !== 'touch') return 52;
    const contactSize = Math.max(Number(event.width) || 0, Number(event.height) || 0);
    return Math.max(56, Math.min(96, (contactSize * 1.35) || 64));
  }

  function scratchLine(from, to, diameter = brushDiameter) {
    if (!context) return;
    const radius = (diameter * dpr) / 2;
    const distance = Math.hypot(to.x - from.x, to.y - from.y);
    const spacing = Math.max(4 * dpr, radius * .42);
    const steps = Math.max(1, Math.ceil(distance / spacing));

    context.save();
    context.globalCompositeOperation = 'destination-out';
    context.globalAlpha = 1;
    context.fillStyle = '#000';
    for (let index = 0; index <= steps; index += 1) {
      const progress = index / steps;
      const x = from.x + ((to.x - from.x) * progress);
      const y = from.y + ((to.y - from.y) * progress);
      const grainCount = Math.max(18, Math.round(radius * .34));
      for (let grain = 0; grain < grainCount; grain += 1) {
        const angle = Math.random() * Math.PI * 2;
        const offsetRadius = radius * Math.sqrt(Math.random()) * .98;
        const grainX = x + (Math.cos(angle) * offsetRadius);
        const grainY = y + (Math.sin(angle) * offsetRadius);
        const grainRadius = Math.max(1.2 * dpr, radius * (.045 + (Math.random() * .11)));
        context.beginPath();
        context.arc(grainX, grainY, grainRadius, 0, Math.PI * 2);
        context.fill();
      }
    }
    context.restore();
  }

  function sprinkleDust(point) {
    if (reduceMotion.matches || moveCount % 2 !== 0) return;
    for (let index = 0; index < 2; index += 1) {
      const flake = document.createElement('span');
      flake.className = 'klaim-scratchcard__flake';
      flake.style.left = `${point.x / dpr}px`;
      flake.style.top = `${point.y / dpr}px`;
      flake.style.setProperty('--flake-x', `${(Math.random() - .5) * 42}px`);
      flake.style.setProperty('--flake-y', `${12 + (Math.random() * 26)}px`);
      flake.style.setProperty('--flake-r', `${(Math.random() - .5) * 180}deg`);
      dust.appendChild(flake);
      window.setTimeout(() => flake.remove(), 460);
    }
  }

  function clearedPercent() {
    if (!context) return 0;
    const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
    const step = Math.max(8, Math.round(9 * dpr));
    let total = 0;
    let clear = 0;
    for (let y = 0; y < canvas.height; y += step) {
      for (let x = 0; x < canvas.width; x += step) {
        total += 1;
        if (pixels[((y * canvas.width + x) * 4) + 3] < 80) clear += 1;
      }
    }
    return Math.round((clear / total) * 100);
  }

  function updateProgress() {
    if (revealed) return;
    const percent = Math.min(100, clearedPercent());
    progress.style.transform = `scaleX(${percent / 100})`;
    status.textContent = percent < 45 ? `Keep scratching / ${percent}%` : 'Revealed';
    if (percent >= 45) reveal();
  }

  function scheduleProgress() {
    if (progressFrame || revealed) return;
    progressFrame = window.requestAnimationFrame(() => {
      progressFrame = null;
      updateProgress();
    });
  }

  function reveal() {
    if (revealed) return;
    revealed = true;
    if (progressFrame) {
      window.cancelAnimationFrame(progressFrame);
      progressFrame = null;
    }
    surface.classList.remove('is-pressing');
    safeSet(window.localStorage, keys.scratched, '1');
    if (teaser) teaser.hidden = true;
    root.classList.add('is-revealed');
    surface.classList.add('is-revealed');
    progress.style.transform = 'scaleX(1)';
    status.textContent = 'Revealed';
    revealButton.hidden = true;
    submitButton.disabled = false;
    intro.textContent = 'KLAIM YOUR REWARD.';
    form.hidden = true;
    form.classList.remove('is-entering');
    window.navigator.vibrate?.(8);
    revealHoldTimer = window.setTimeout(() => {
      revealHoldTimer = null;
      if (!revealed) return;
      surface.classList.add('is-flying');
      form.hidden = false;
      if (finePointer.matches) window.requestAnimationFrame(() => emailInput.focus({ preventScroll: true }));
    }, reduceMotion.matches ? 0 : 3000);
  }

  function startScratch(event) {
    if (revealed) return;
    drawing = true;
    brushDiameter = brushDiameterFromEvent(event);
    surface.classList.add('is-pressing');
    lastPoint = pointFromEvent(event);
    canvas.setPointerCapture?.(event.pointerId);
    scratchLine(lastPoint, { x: lastPoint.x + .1, y: lastPoint.y + .1 }, brushDiameter);
    scheduleProgress();
  }

  function moveScratch(event) {
    if (!drawing || revealed) return;
    const point = pointFromEvent(event);
    brushDiameter = brushDiameterFromEvent(event);
    scratchLine(lastPoint, point, brushDiameter);
    moveCount += 1;
    sprinkleDust(point);
    scheduleProgress();
    lastPoint = point;
  }

  function endScratch() {
    if (!drawing) return;
    drawing = false;
    surface.classList.remove('is-pressing');
    lastPoint = null;
    updateProgress();
  }

  function focusableElements() {
    return [...dialog.querySelectorAll('button:not([disabled]):not([hidden]), a[href], input:not([disabled]):not([hidden]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => element.offsetParent !== null);
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || root.hidden) return;
    const focusable = focusableElements();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function reset() {
    window.clearTimeout(mainHideTimer);
    mainHideTimer = null;
    window.clearTimeout(revealHoldTimer);
    revealHoldTimer = null;
    issuedCode = '';
    revealed = false;
    moveCount = 0;
    drawing = false;
    if (progressFrame) {
      window.cancelAnimationFrame(progressFrame);
      progressFrame = null;
    }
    brushDiameter = 52;
    surface.classList.remove('is-pressing');
    surface.classList.remove('is-revealed');
    surface.classList.remove('is-flying');
    root.classList.remove('is-revealed');
    root.classList.remove('is-claimed');
    main.classList.remove('is-completing');
    dust.replaceChildren();
    revealButton.hidden = false;
    submitButton.disabled = true;
    submitButton.textContent = 'Claim reward';
    form.reset();
    form.hidden = true;
    form.classList.remove('is-entering');
    error.textContent = '';
    intro.textContent = 'Scratch to reveal your offer. Enter your email to save it and use it at checkout.';
    progress.style.transform = 'scaleX(0)';
    status.textContent = 'Scratch to reveal';
    main.hidden = false;
    success.hidden = true;
    success.classList.remove('is-entering');
    copyButton.classList.remove('is-copied');
    copyButton.title = 'Copy code';
    copyButton.setAttribute('aria-label', 'Copy discount code');
    setReward();
  }

  function cancelScheduledOpen() {
    if (!openTimer) return;
    window.clearTimeout(openTimer);
    openTimer = null;
  }

  function open(options = {}) {
    const automatic = options.automatic === true;
    if (!root.hidden) return;
    if (automatic) {
      if (!eligible()) return;
      if (safeGet(window.sessionStorage, keys.autoOpenedForSession)) return;
      safeSet(window.sessionStorage, keys.autoOpenedForSession, '1');
    }
    cancelScheduledOpen();
    previousFocus = document.activeElement;
    window.clearTimeout(closeTimer);
    const resumeClaim = Boolean(
      safeGet(window.localStorage, keys.scratched) &&
      !safeGet(window.localStorage, keys.claimed)
    );
    if (!resumeClaim) reset();
    root.hidden = false;
    if (teaser) teaser.hidden = true;
    document.documentElement.classList.add('klaim-scratchcard-open');
    window.requestAnimationFrame(() => {
      if (resumeClaim) {
        revealed = true;
        root.classList.add('is-revealed');
        surface.classList.add('is-revealed');
        surface.classList.add('is-flying');
        progress.style.transform = 'scaleX(1)';
        status.textContent = 'Revealed';
        revealButton.hidden = true;
        submitButton.disabled = false;
        form.hidden = false;
        form.classList.remove('is-entering');
      } else {
        drawCover();
      }
      dialog.focus({ preventScroll: true });
    });
  }

  function teaserEligible() {
    if (preview) return true;
    if (safeGet(window.sessionStorage, keys.teaserDismissedForSession)) return false;
    return !safeGet(window.localStorage, keys.claimed) || Date.now() >= nextEligibleAt();
  }

  function showTeaser() {
    if (teaser && teaserEligible()) teaser.hidden = false;
  }

  function closeTeaser() {
    if (!teaser) return;
    cancelScheduledOpen();
    teaser.hidden = true;
    clearPendingOffer();
    safeSet(window.sessionStorage, keys.teaserDismissedForSession, '1');
  }

  function close() {
    if (root.hidden) return;
    cancelScheduledOpen();
    window.clearTimeout(mainHideTimer);
    mainHideTimer = null;
    window.clearTimeout(revealHoldTimer);
    revealHoldTimer = null;
    const subscribed = Boolean(safeGet(window.localStorage, keys.claimed));
    if (subscribed) {
      setFullCooldown(SUBSCRIBER_COOLDOWN_MS);
    } else {
      setPopupCooldown(VISITOR_COOLDOWN_MS);
    }
    clearPendingOffer();
    root.classList.add('is-closing');
    closeTimer = window.setTimeout(() => {
      root.hidden = true;
      root.classList.remove('is-closing');
      document.documentElement.classList.remove('klaim-scratchcard-open');
      showTeaser();
      previousFocus?.focus?.({ preventScroll: true });
    }, reduceMotion.matches ? 0 : 1200);
  }

  async function subscribe(email, couponCode) {
    const response = await window.fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(config.companyId)}`, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: '2026-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'KLAIM Scratchcard Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  properties: {
                    'KLAIM Signup Source': 'Scratchcard Popup',
                    'KLAIM Form Name': config.formName,
                    'KLAIM Marketing Consent': true,
                    'KLAIM Offer Shown': reward.title,
                    'KLAIM Coupon Code': couponCode,
                    'KLAIM Signup Page URL': window.location.href
                  },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: config.listId } } }
        }
      })
    });

    if (!response.ok) throw new Error(`Klaviyo subscription failed: ${response.status}`);

    window.klaviyo?.track?.('Scratchcard Claimed', {
      'Form Name': config.formName,
      'Offer Type': reward.code === 'YEEZY175' ? 'Gift' : reward.code === 'SCRATCHSHIP' ? 'Shipping' : 'Coupon',
      'Offer Value': reward.title,
      'Coupon Code': couponCode
    });
  }

  async function issueDiscount(email) {
    const response = await window.fetch(config.discountEndpoint, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        email,
        rewardKey: reward.code,
        website: websiteInput.value
      })
    });
    const claim = await response.json().catch(() => ({}));
    if (!response.ok || !claim.code) throw new Error(claim.error || 'Discount creation failed.');
    const issuedReward = rewards.find((candidate) => candidate.code === claim.rewardKey);
    if (!issuedReward) throw new Error('Unknown issued reward.');
    reward = issuedReward;
    issuedCode = claim.code;
    setReward();
    return claim;
  }

  function otherDialogIsOpen() {
    return [...document.querySelectorAll('[role="dialog"]')].some((candidate) => {
      if (candidate === dialog || root.contains(candidate)) return false;
      if (candidate.getAttribute('aria-modal') !== 'true') return false;
      const style = window.getComputedStyle(candidate);
      return style.display !== 'none' && style.visibility !== 'hidden' && candidate.getClientRects().length > 0;
    });
  }

  function eligible() {
    if (preview) return true;
    return Date.now() >= nextEligibleAt();
  }

  function scheduleOpen(delay = 5500, attempts = 0) {
    if (safeGet(window.sessionStorage, keys.teaserDismissedForSession)) return;
    if (safeGet(window.sessionStorage, keys.autoOpenedForSession)) return;
    if (!eligible()) return;
    cancelScheduledOpen();
    openTimer = window.setTimeout(() => {
      openTimer = null;
      if (safeGet(window.sessionStorage, keys.teaserDismissedForSession)) return;
      if (safeGet(window.sessionStorage, keys.autoOpenedForSession)) return;
      if (!eligible()) return;
      if (otherDialogIsOpen()) {
        if (attempts >= 1) showTeaser();
        scheduleOpen(4500, attempts + 1);
        return;
      }
      open({ automatic: true });
    }, preview ? 150 : delay);
  }

  function start() {
    if (!eligible()) {
      showTeaser();
      return;
    }
    if (preview) {
      scheduleOpen();
      return;
    }
    if (window.Shopify?.designMode && !preview) return;
    if (window.__klaimSiteIntroState === 'pending') {
      window.addEventListener('klaim:site-intro-complete', () => scheduleOpen(), { once: true });
    } else {
      scheduleOpen();
    }
  }

  canvas.addEventListener('pointerdown', startScratch);
  canvas.addEventListener('pointermove', moveScratch);
  canvas.addEventListener('pointerup', endScratch);
  canvas.addEventListener('pointercancel', endScratch);
  canvas.addEventListener('pointerleave', endScratch);
  revealButton.addEventListener('click', reveal);
  closeButtons.forEach((button) => button.addEventListener('click', close));
  teaserOpen?.addEventListener('click', open);
  teaserClose?.addEventListener('click', closeTeaser);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!revealed) {
      error.textContent = 'Reveal your reward first.';
      return;
    }
    if (!emailInput.validity.valid) {
      error.textContent = 'Enter a valid email address.';
      emailInput.focus();
      return;
    }
    const email = emailInput.value.trim();
    error.textContent = '';
    submitButton.disabled = true;
    submitButton.textContent = 'Claiming...';

    try {
      const claim = await issueDiscount(email);
      await subscribe(email, claim.code);
      safeSet(window.localStorage, keys.claimed, claim.code);
      setFullCooldown(SUBSCRIBER_COOLDOWN_MS);
      if (teaser) teaser.hidden = true;
      main.classList.add('is-completing');
      root.classList.add('is-claimed');
      success.hidden = false;
      success.classList.remove('is-entering');
      window.requestAnimationFrame(() => success.classList.add('is-entering'));
      successTitle.focus({ preventScroll: true });
      mainHideTimer = window.setTimeout(() => {
        mainHideTimer = null;
        main.hidden = true;
      }, reduceMotion.matches ? 0 : 1500);
    } catch (claimError) {
      const safeMessages = new Set([
        'Too many claims. Try again tomorrow.',
        'Could not create your code. Try again.'
      ]);
      error.textContent = safeMessages.has(claimError?.message)
        ? claimError.message
        : 'Could not save your reward. Try again.';
      submitButton.disabled = false;
      submitButton.textContent = 'Claim reward';
    }
  });

  copyButton.addEventListener('click', async () => {
    if (!issuedCode) return;
    try {
      await window.navigator.clipboard.writeText(issuedCode);
    } catch (_) {
      const helper = document.createElement('textarea');
      helper.value = issuedCode;
      helper.style.position = 'fixed';
      helper.style.opacity = '0';
      document.body.appendChild(helper);
      helper.select();
      document.execCommand('copy');
      helper.remove();
    }
    copyButton.classList.add('is-copied');
    copyButton.title = 'Copied';
    copyButton.setAttribute('aria-label', 'Discount code copied');
    window.setTimeout(() => {
      copyButton.classList.remove('is-copied');
      copyButton.title = 'Copy code';
      copyButton.setAttribute('aria-label', 'Copy discount code');
    }, 1600);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) close();
    trapFocus(event);
  });

  window.addEventListener('resize', () => {
    if (!revealed && !root.hidden) drawCover();
  });

  window.addEventListener('pagehide', cancelScheduledOpen);

  setReward();
  start();
})();
